export const ESTABLISHMENT_APP_TIMESTAMP_VERSION_KEY = '_Slenv__appTimestampVersion'

export const ESTABLISHMENT_SECTOR = {
  COMMERCIAL: 1,
  AUTOMOTIVE: 2,
  HOTEL: 3,
  LOAN: 4,
}

export const ESTABLISHMENT_SECTORS = [
  {
    value: ESTABLISHMENT_SECTOR.COMMERCIAL,
    label: "Comercial"
  },
  {
    value: ESTABLISHMENT_SECTOR.AUTOMOTIVE,
    label: "Automotriz"
  },
  // {
  //   value: ESTABLISHMENT_SECTOR.HOTEL,
  //   label: "Hotelero"
  // },
  {
    value: ESTABLISHMENT_SECTOR.LOAN,
    label: "Cobranzas"
  }
]

export const ESTABLISHMENT_TREASURY_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
}

export const ESTABLISHMENT_TREASURY_STATUS_OPTIONS = [
  {
    value: ESTABLISHMENT_TREASURY_STATUS.ACTIVE,
    label: "Activa"
  },
  {
    value: ESTABLISHMENT_TREASURY_STATUS.INACTIVE,
    label: "Inactiva"
  }
]
